import PropTypes from 'prop-types';

import Icon from '@/atoms/Icon/Icon';
import Text from '@/atoms/Text/Text';
import RichText from '@/molecules/RichText/RichText';

import { TEXT_BASE_CLASS } from '@/atoms/Text/Text.constants';

export default function CategorySidebar({
  category,
  closeCategorySidebar,
  goToPreviousCategory,
  goToNextCategory,
  nextCategory,
  onStationClick,
  prevCategory,
  entries,
}) {
  if (!category) return null;

  return (
    <div
      className={`aaco-detail-category w-full md:w-1/2
      relative md:absolute
      md:right-0 md:opacity-1 z-30
      mt-[40vh] md:mt-0
      min-h-[40vh]
      md:transition-[width] md:duration-500 md:ease-out	${
        category ? '' : 'hidden md:block md:w-0 md:opacity-50 '
      }`}
    >
      <div
        className={`aaco-detail-category__body w-full md:h-screen md:transition-all md:duration-200 bg-warm-grey ${
          category ? 'md:bg-warm-grey' : 'md:bg-transparent'
        } flex items-end flex-col overflow-y-auto min-h-[60vh]`}
      >
        <div className="aaco-detail-category__close hidden md:flex mt-[53px] mb-[41px] mr-[55px]">
          <div className="cursor-pointer" onClick={closeCategorySidebar}>
            <Icon name="close" className="w-6 h-6 text-acacia" />
          </div>
        </div>
        <div
          className={`aaco-detail-category w-full flex flex-col self-end p-[30px] pt-[65px] md:pt-0  md:px-[100px] mb-[90px] text-acacia`}
        >
          <div className="aaco-category-detail__title mb-[51.6px] md:mb-[55px]">
            <Text tag="h4" style="text-black hidden md:block">
              {category?.name}
            </Text>
            <Text tag="h5" style="text-black block md:hidden">
              {category?.name}
            </Text>
          </div>
          <div className="aaco-category-detail__content flex flex-col gap-y-[30px]">
            <div className="aaco-category-detail__description">
              {category?.description?.content?.length > 0 &&
                category.description.content.map(
                  ({ content, nodeType }, index) => {
                    return (
                      <RichText
                        entries={entries}
                        content={content}
                        key={index}
                        nodeType={nodeType}
                        richTextStyle={{
                          paragraph: {
                            customFont:
                              TEXT_BASE_CLASS['body'] + ' text-acacia',
                            blockquoteFont:
                              TEXT_BASE_CLASS['blockquote'] + 'text-acacia',
                            paragraphWrapper: 'leading-5 mb-4',
                          },
                          list: {
                            paragraph: {
                              customFont:
                                TEXT_BASE_CLASS['body'] + ' text-acacia',
                              blockquoteFont:
                                TEXT_BASE_CLASS['blockquote'] + 'text-acacia',
                            },
                            ul: 'marker:text-acacia mb-4',
                          },
                        }}
                      />
                    );
                  }
                )}
            </div>
            <div className="aaco-category-detail__stations">
              {category?.stations?.detail?.length > 0 && (
                <>
                  <Text tag="button" style="text-black uppercase">
                    {category?.name + ' stations'}
                  </Text>
                  {category.stations.detail.map((s, stationIdx) => (
                    <div
                      className="aaco-category-detail__station py-5 flex items-center justify-between border-b border-b-black"
                      key={s.id}
                      role="button"
                      onClick={() =>
                        onStationClick({
                          categoryIdx: category.stations.categoryIdx,
                          detail: s,
                          stationIdx,
                        })
                      }
                    >
                      {s.name}
                      <Icon
                        className="hidden md:block text-acacia"
                        height={24}
                        name="arrow-head"
                        width={24}
                      />
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="aaco-detail-category__footer absolute h-[55px] w-full bottom-0 bg-warmer-grey text-white flex items-center justify-between">
        <div
          className={`flex items-center ${
            prevCategory ? 'cursor-pointer' : 'invisible'
          }`}
          role="button"
          onClick={prevCategory ? goToPreviousCategory : null}
        >
          <div className="w-[40px] pl-3 mx-auto">
            <Icon
              className="mx-auto text-black"
              name="button-arrow-left"
              height={6.74}
              width={11.67}
            />
          </div>
          <Text
            tag="button"
            style="text-black hover:underline hover:underline-offset-[5px] hover:decoration-[1.5px] hover:decoration-black"
          >
            {prevCategory}
          </Text>
        </div>
        <div
          className={`flex items-center ${
            nextCategory ? 'cursor-pointer' : 'invisible'
          }`}
          role="button"
          onClick={nextCategory ? goToNextCategory : null}
        >
          <Text
            tag="button"
            style="text-black hover:underline hover:underline-offset-[5px] hover:decoration-[1.5px] hover:decoration-black"
          >
            {nextCategory}
          </Text>
          <div className="w-[40px] pr-3">
            <Icon
              className="mx-auto text-black"
              name="button-arrow-right"
              height={6.74}
              width={11.67}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

CategorySidebar.propTypes = {
  category: PropTypes.shape({
    description: PropTypes.shape({
      content: PropTypes?.array,
    }),
    closeCategorySidebar: PropTypes.func,
    goToPreviousCategory: PropTypes.func,
    goToNextCategory: PropTypes.func,
    name: PropTypes.string,
    nextCategory: PropTypes.string,
    prevCategory: PropTypes.string,
    onStationClick: PropTypes.func,
  }),
};
